import React from 'react';

const stopEventPropagation = (event: React.TouchEvent) => event.stopPropagation();

/**
 * Pass the return value of this function to a select input.
 * This makes sure that the Kalep and MaterialUI select inputs work as expected on iOS and Android,
 * when placed inside an overlay (such as a dialog).
 */
export const stopTouchEventsPropagation = () => ({
  onTouchStart: stopEventPropagation,
  onTouchEnd: stopEventPropagation,
  onTouchEndCapture: stopEventPropagation,
  onTouchStartCapture: stopEventPropagation,
  onTouchMove: stopEventPropagation,
  onTouchMoveCapture: stopEventPropagation,
  onTouchCancel: stopEventPropagation,
  onTouchCancelCapture: stopEventPropagation,
});
